import { render, staticRenderFns } from "./fsModalUnarchive.vue?vue&type=template&id=cd89501a"
import script from "./fsModalUnarchive.vue?vue&type=script&lang=js"
export * from "./fsModalUnarchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports